export default __webpack_public_path__ + "static/media/flitbase-alt.aaa2e6d1.svg";